import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_MEAL_PARSING = `${BASE_URL}/api/meals`;

export class MealParsingApi {
  static async parseMealText(text) {
    return (
      await axiosInstance.post(`${BASE_URL_MEAL_PARSING}/ai-parse`, { text })
    ).data;
  }

  static async parseMealFromUrl(url) {
    return (
      await axiosInstance.post(`${BASE_URL_MEAL_PARSING}/ai-parse-link`, { url })
    ).data;
  }
}
